import { Component, input, output } from '@angular/core'
import { AgGridAngular, type INoRowsOverlayAngularComp } from 'ag-grid-angular'
import { TablePaginationComponent } from '../public/table/table-pagination/table-pagination.component'
import { TableSortService } from '../public/table/services/table-sort.service'
import { IdrResult } from './idr-investigation.service'
import { IdrColDef } from './idr-columns'
import { INoRowsOverlayParams } from 'ag-grid-community'


type NoRowsComponentParams = Readonly<{
  onEditFilters: () => void
}>

const defaultParams: NoRowsComponentParams = {
  onEditFilters: () => void 0,
}

@Component({
  selector: 'app-idr-data-table-no-rows',
  template: `
    <p>
      No results found for
      <a href='#' (click)="handleEditFilters($event)">selected filters</a>.
    </p>
  `,
  styles: `
    :host {
      pointer-events: auto;
      font-size: 110%;
    }
  `,
})
class IdrTableNoRowsOverlayComponent implements INoRowsOverlayAngularComp {
  private params: NoRowsComponentParams = defaultParams

  protected handleEditFilters(event: MouseEvent) {
    event.preventDefault()
    this.params.onEditFilters()
  }

  agInit(params: INoRowsOverlayParams & NoRowsComponentParams) {
    this.refresh(params)
  }

  refresh(params: INoRowsOverlayParams & NoRowsComponentParams) {
    this.params = params
  }
}

@Component({
  selector: 'app-idr-data-table',
  imports: [AgGridAngular, TablePaginationComponent],
  providers: [TableSortService],
  template: `
      <ag-grid-angular
        class="app-table"
        [class.app-table-empty]="!loading() && rowData().length === 0"
        [columnDefs]="columnDefs()"
        [rowData]="rowData()"
        [suppressNoRowsOverlay]="loading()"
        [suppressPaginationPanel]="true"
        [suppressDragLeaveHidesColumns]="true"
        [noRowsOverlayComponent]="NoRowsOverlayComponent"
        [noRowsOverlayComponentParams]="noRowsParams"  
        [pagination]="false"
        [enableCellTextSelection]="true"
      />
      <app-table-pagination
        [pageNumber]="pageNumber()"
        [pageSize]="pageSize()"
        [totalResults]="totalResultCount()"
        (pageNumberChange)="pageNumberChange.emit($event)"
      />
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      justify-content: start;
    }
    .app-table {
      height: calc(100vh - 220px);
    }
    app-table-pagination {
      margin-top: 1rem;
    }
  `,
})
export class IdrDataTableComponent {
  readonly columnDefs = input.required<IdrColDef[]>()
  readonly rowData = input.required<IdrResult[]>()
  readonly pageNumber = input.required<number>()
  readonly pageSize = input.required<number>()
  readonly totalResultCount = input.required<number>()
  readonly loading = input.required<boolean>()

  readonly pageNumberChange = output<number>()
  readonly editFilters = output()

  protected readonly NoRowsOverlayComponent = IdrTableNoRowsOverlayComponent

  protected readonly noRowsParams: NoRowsComponentParams = {
    onEditFilters: () => this.editFilters.emit(),
  }
}
